export const Item = [
    {
        id: 1,
        category: "macbook",
        title: "Apple Macbook Pro",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/macbookPro.jpg",
        color: "red",
        brand: "apple",
        price: 599
    },
    {
        id: 2,
        category: "macbook",
        title: "Apple Macbook Air",
        decripation: "This is one of the most popular iPhone.",
        image: "./images/Apple_Macbook_Air.png",
        color: "blue",
        brand: "apple",
        price: 499
    },
    {
        id: 3,
        category: "iphone",
        title: "Apple iPhone 14 Pro",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/iphone14.jpg",
        color: "red",
        brand: "Samsung",
        price: 499
    },
    {
        id: 4,
        category: "iphone",
        title: "iPhone 13 Pro",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/iphone13.jpg",
        color: "red",
        brand: "apple",
        price: 99
    },
    {
        id: 5,
        category: "ipad",
        title: "Apple iPad",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/ipad13.jpg",
        color: "yellow",
        brand: "Samsung",
        price: 277
    },
    {
        id: 6,
        category: "watch",
        title: "Apple watch 21-1",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/iwatch_white.jpg",
        color: "black",
        brand: "apple",
        price: 234
    },
    {
        id: 7,
        category: "accessores",
        title: "Apple Headphone",
        decripation: "This is one of the most popular iPhone.",
        image: "./asset/products/apple_headphone.png",
        color: "gold",
        brand: "Samsung",
        price: 35
    },
    {
        id: 8,
        category: "ipad",
        title: "Apple iPad 2A",
        decripation: "This is one of the most popular iPhone.",
        image: "./asset/products/apple_iPod_2A.png",
        color: "gray",
        brand: "apple",
        price: 129
    },
    {
        id: 9,
        category: "accessores",
        title: "Apple Headphone",
        decripation: "This is one of the most popular iPhone.",
        image: "./asset/products/apple_headphone.png",
        color: "gold",
        brand: "Samsung",
        price: 35
    },
    {
        id: 10,
        category: "ipad",
        title: "Apple iPad 2A",
        decripation: "This is one of the most popular iPhone.",
        image: "./images/Apple_Macbook_Air.png",
        color: "gray",
        brand: "apple",
        price: 129
    },
    {
        id: 11,
        category: "accessores",
        title: "Apple Headphone",
        decripation: "This is one of the most popular iPhone.",
        image: "./asset/products/apple_headphone.png",
        color: "gold",
        brand: "Samsung",
        price: 35
    },
    {
        id: 12,
        category: "ipad",
        title: "Apple iPad 2A",
        decripation: "This is one of the most popular iPhone.",
        image: "./downloadImages/16-inch-macbook-pro.webp",
        color: "gray",
        brand: "apple",
        price: 129
    },
    
]

